import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Grid } from '@tq/ui-components';

import { useConsultation } from 'api';
import { HttpError } from 'types';
import {
  ArchivedConsultationResponse,
  OpenConsultationResponse,
  ResponseHeader,
} from './components';
import { useNavigate } from '../../hooks';

export const ConsultationResponse: React.FC = () => {
  const { id } = useParams();
  const consultationId = +(id ?? 0);
  const { data: consultation, error, isError } = useConsultation(+consultationId);
  const { navigateToErrorPage } = useNavigate();

  useEffect(() => {
    if (isError && error) {
      navigateToErrorPage(error as HttpError);
    }
  }, [isError, error, navigateToErrorPage]);

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Grid gridGap={4} mb={12}>
        <ResponseHeader consultation={consultation} />
        {consultation?.isArchived ? (
          <ArchivedConsultationResponse />
        ) : (
          <OpenConsultationResponse />
        )}
      </Grid>
    </Container>
  );
};
